import "../chunks/chunk.O2GMJYSL.js";
import {
  getBasePath,
  setBasePath
} from "../chunks/chunk.BLF5UWQW.js";
import "../chunks/chunk.7RPYXGIF.js";
import "../chunks/chunk.K2NRSETB.js";
export {
  getBasePath,
  setBasePath
};
